import{styled as m}from"@mui/material/styles";const r=m("div")((({theme:m,$isNarrowColumn:r})=>({...r&&{[m.breakpoints.up("md")]:{margin:"0 10%"}}})));export{r as ColumnContent};
//# sourceMappingURL=styles.js.map
